import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import { useMemo, useState } from "react";
import { palette } from "../../themes/theme";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dropdown from "../../component/Dropdown";
import { logoutUser } from "../../redux/thunk/userThunk";

const MapHeader = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await dispatch(logoutUser()).unwrap();
    navigate("/");
  };

  const userMenu = useMemo(
    () => [
      {
        title: `${user.adminData.firstName} ${user.adminData.lastName}`,
        onClick: () => {},
        disableHover: true,
      },
      {
        title: (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5vw",
            }}
          >
            Logout <LogoutIcon />
          </Box>
        ),
        onClick: handleLogout,
      },
    ],
    [user]
  );

  const superAdminMenu = useMemo(
    () => [
      {
        title: `${user.adminData.firstName} ${user.adminData.lastName}`,
        onClick: () => {},
        disableHover: true,
      },
      {
        title: "User Management",
        onClick: () => navigate("/admin/user-management"),
      },
      {
        title: (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5vw",
            }}
          >
            Logout <LogoutIcon />
          </Box>
        ),
        onClick: handleLogout,
      },
    ],
    [user]
  );
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Box sx={{ position: "absolute", right: 10, top: 10 }}>
        <IconButton
          sx={{
            background: palette.background.light,
            borderRadius: 1,
            border: `1px solid ${palette.text.dark}`,
            p: "6px",
            height: "fit-content",
            "&:hover": {
              background: palette.background.light,
              border: `1px solid ${palette.text.dark}`,
            },
          }}
          onClick={handleClick}
        >
          {anchorEl ? (
            <CloseIcon fontSize="medium" color="primary" />
          ) : (
            <MenuIcon fontSize="medium" color="primary" />
          )}
        </IconButton>
        <Dropdown
          anchorEl={anchorEl}
          handleClose={handleClose}
          data={
            user && user?.adminData?.roles?.name === "superadmin"
              ? superAdminMenu
              : userMenu
          }
        />
      </Box>
    </>
  );
};

export default MapHeader;
